import { RcFile } from "antd/lib/upload";
import Resizer from "react-image-file-resizer";
import Compressor from "compressorjs";

export const normFile = (e: any) => {
  // console.log('Upload event:', e);
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

export const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

export const resizeImageFile = (file: RcFile, maxWidth?: number, maxHeight?: number) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth || 800,
      maxHeight || 800,
      file.type || "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "blob",
      300,
      300,
    );
  });

export const resizeFile = async (
  file: RcFile,
  maxSize: number, // in MB
) => {
  // console.log("Resizing file:", file.name, "Size:", file.size);
  const originalFileSize = file.size / 1024 / 1024; // in MB

  if (originalFileSize <= maxSize) {
    // console.log("File size is within the limit, no compression needed.", {
    //   originalFileSize,
    //   maxSize,
    // });
    return file;
  }

  const quality = Math.floor((maxSize / originalFileSize) * 100) / 100;
  // console.log({
  //   originalFileSize,
  //   maxSize,
  //   quality,
  // });

  const smallerFile = (await resizeImageFile(file)) || file;

  return new Promise((resolve) => {
    new Compressor(smallerFile instanceof Blob ? smallerFile : file, {
      quality: quality,
      success: (compressedFile) => {
        resolve(compressedFile);
        // console.log("File compressed successfully:", compressedFile);
      },
      error(err) {
        console.error("Error compressing file:", err);
        resolve(file); // Fallback to original file if compression fails
      },
    });
  });
};
